<div class="w-full">
  <div class="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-slate-900 mb-2">Liquidaciones</h1>
      <p class="text-slate-600">Depósitos netos sincronizados desde el proveedor de pagos</p>
    </div>
  </div>

  @if (loading() && !initialLoadDone()) {
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden p-6">
      <p-skeleton width="100%" height="12rem" />
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        type="button"
        (click)="loadList()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 ">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50">
        <div class="flex flex-col lg:flex-row lg:items-end gap-4 justify-between">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-100 text-emerald-700">
                <i class="pi pi-building-columns"></i>
              </span>
              Listado
            </h2>
            <p class="text-sm text-slate-500 mt-1">Filtra por rango de fecha de negocio.</p>
          </div>
          <form [formGroup]="filtersForm" class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2 w-full lg:w-auto">
            <p-floatlabel variant="on" class="w-full min-w-0 col-span-2 sm:w-52">
              <p-datepicker
                inputId="businessDateRange"
                formControlName="businessDateRange"
                selectionMode="range"
                [readonlyInput]="true"
                showIcon
                iconDisplay="input"
                dateFormat="dd/mm/yy"
                size="small"
                class="w-full" />
              <label for="businessDateRange">Fecha negocio</label>
            </p-floatlabel>
            <div class="flex gap-2 col-span-2 sm:col-span-1">
              <p-button label="Limpiar" severity="secondary" size="small" type="button" (onClick)="clearFilters()" />
              <p-button label="Buscar" size="small" type="button" (onClick)="applyFilters()" />
            </div>
          </form>
        </div>
      </div>

      <p-table
        [value]="items()"
        dataKey="id"
        [lazy]="true"
        [totalRecords]="totalItems()"
        [first]="currentPage() * pageSize()"
        [rows]="pageSize()"
        [rowsPerPageOptions]="pageSizeOptions"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
        [loading]="loading()"
        [paginator]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [tableStyle]="{ 'min-width': '60rem' }"
        styleClass="reconciliations-primeng-table p-datatable-striped p-datatable-sm"
        [rowHover]="true"
        paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end">
        <ng-template pTemplate="header">
          <tr>
            <th class="!px-5 w-12"></th>
            <th class="!px-5 hidden sm:table-cell min-w-[12rem]">Beneficiario</th>
            <th class="!px-5">Fecha negocio</th>
            <th class="!px-5 text-right">Total</th>
            <th class="!px-5 text-right w-28">Acciones</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr
            class="cursor-pointer hover:!bg-emerald-50/40 transition-colors !border-slate-100"
            (click)="openDrawer(row)">
            <td class="!px-5 !py-3">
              <span class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-600">
                <i class="pi pi-list"></i>
              </span>
            </td>
            <td class="!px-5 !py-3 text-sm text-slate-700 hidden sm:table-cell max-w-[16rem]">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span
                  class="font-medium text-slate-800 font-mono truncate"
                  [title]="row.transferClabe || ''">
                  {{ row.transferClabe || '—' }}
                </span>
                <span class="text-xs text-slate-500 truncate" [title]="row.transferBeneficiaryName || ''">
                  {{ row.transferBeneficiaryName || '—' }}
                </span>
              </div>
            </td>
            <td class="!px-5 !py-3 text-sm text-slate-800">
              {{ row.businessDate || '—' }}
            </td>
            
            <td class="!px-5 !py-3 text-sm text-right font-medium text-slate-900">
              {{ row.totalAmount != null ? (row.totalAmount | number : '1.2-2') : '—' }}
            </td>
            <td class="!px-5 !py-3 text-right" (click)="$event.stopPropagation()">
              <p-button
                icon="pi pi-external-link"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                pTooltip="Ver detalle"
                (onClick)="row.id && goToDetail(row.id)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="!px-5 !py-12 !text-center !text-slate-500">
              No hay liquidaciones en el rango seleccionado.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <p-drawer
    [visible]="isDrawerOpen()"
    (visibleChange)="onDrawerVisibleChange($event)"
    position="right"
    styleClass="!w-[min(96vw,80rem)]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <span class="font-semibold text-slate-900">Detalle de liquidación</span>
    </ng-template>
    @if (drawerLoading()) {
      <p-skeleton width="100%" height="8rem" class="mb-4" />
      <p-skeleton width="100%" height="12rem" />
    } @else if (drawerReconciliation(); as d) {
      <div class="space-y-5 text-sm -mx-1">
        <div class="rounded-lg border border-slate-200 bg-slate-50/60 p-4">
          <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-3">Resumen de liquidación</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5">
            <div>
              <p class="text-[11px] uppercase text-slate-500">ID interno</p>
              <p class="font-medium text-slate-900">{{ d.id }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">ID externo</p>
              <p class="font-medium text-slate-900 break-all">{{ d.externalReconciliationId || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Proveedor</p>
              <p>{{ d.paymentProvider || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Tipo</p>
              <p>{{ d.reconciliationType || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Fecha negocio</p>
              <p>{{ d.businessDate || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Creado en proveedor</p>
              <p>{{ d.providerCreatedAt || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Disperso / fragmentado</p>
              <p>{{ d.scattered ? 'Sí' : 'No' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Subtotal</p>
              <p class="text-right sm:text-left">{{ d.subTotal != null ? (d.subTotal | number : '1.2-2') : '—' }}</p>
            </div>
            <div class="sm:col-span-2">
              <p class="text-[11px] uppercase text-slate-500">Total liquidación</p>
              <p class="text-lg font-semibold text-slate-900">
                {{ d.totalAmount != null ? (d.totalAmount | number : '1.2-2') : '—' }}
              </p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Primera sincronización</p>
              <p class="text-xs">{{ d.firstFetchedAt || '—' }}</p>
            </div>
            <div>
              <p class="text-[11px] uppercase text-slate-500">Última actualización</p>
              <p class="text-xs">{{ d.lastRefreshedAt || '—' }}</p>
            </div>
          </div>
          @if (d.transferBank || d.transferClabe || d.transferConcept || d.transferBeneficiaryName || d.transferTrackCode || d.transferUrlCep || d.transferOperationAt) {
            <div class="mt-4 pt-4 border-t border-slate-200">
              <h4 class="text-[11px] font-semibold uppercase text-slate-500 mb-2">Datos de transferencia</h4>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-xs text-slate-700">
                <div><span class="text-slate-500">Banco:</span> {{ d.transferBank || '—' }}</div>
                <div><span class="text-slate-500">CLABE:</span> {{ d.transferClabe || '—' }}</div>
                <div class="sm:col-span-2"><span class="text-slate-500">Concepto:</span> {{ d.transferConcept || '—' }}</div>
                <div class="sm:col-span-2"><span class="text-slate-500">Beneficiario:</span> {{ d.transferBeneficiaryName || '—' }}</div>
                <div><span class="text-slate-500">Track:</span> {{ d.transferTrackCode || '—' }}</div>
                <div><span class="text-slate-500">Operación:</span> {{ d.transferOperationAt || '—' }}</div>
                @if (d.transferUrlCep) {
                  <div class="sm:col-span-2 break-all">
                    <span class="text-slate-500">CEP:</span>
                    <a [href]="d.transferUrlCep" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline ml-1">{{ d.transferUrlCep }}</a>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        @if (d.lines?.length) {
          @let totals = lineTotals(d.lines);
          <div>
            <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
              Movimientos ({{ d.lines.length }})
            </h3>
            <p-table
              [value]="d.lines"
              scrollable="true"
              scrollHeight="420px"
              [tableStyle]="{ 'min-width': '48rem' }"
              styleClass="reconciliation-drawer-lines-table p-datatable-sm p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th class="!px-2">Venta</th>
                  <th class="!px-2">Cliente</th>
                  <th class="!px-2">Referencia</th>
                  <th class="!px-2">Fecha txn</th>
                  <th class="!px-2 text-right">Monto</th>
                  <th class="!px-2 text-right">Comisión</th>
                  <th class="!px-2 text-right">Depósito</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-line>
                <tr>
                  <td class="!px-2 max-w-[8rem]" (click)="$event.stopPropagation()">
                    <div class="flex flex-col gap-0.5 min-w-0">
                      @if (line.sale?.id) {
                        <button
                          type="button"
                          class="text-left text-sm font-medium text-violet-700 hover:underline truncate max-w-full"
                          (click)="openSaleDetails(line.sale.id, $event)">
                          {{ saleLabel(line) }}
                        </button>
                      } @else {
                        <span class="text-slate-400">—</span>
                      }
                      @if (line.charge?.id) {
                        <button
                          type="button"
                          class="text-left text-xs font-medium text-sky-700 hover:underline"
                          (click)="openChargeDetails(line.charge, $event)">
                          {{ chargeLabel(line) }}
                        </button>
                      } @else {
                        <span class="text-xs text-slate-400">—</span>
                      }
                    </div>
                  </td>
                  <td class="!px-2 max-w-[10rem]" (click)="$event.stopPropagation()">
                    @if (line.customer?.id) {
                      <button
                        type="button"
                        class="text-left text-sm text-slate-800 hover:text-sky-700 hover:underline truncate max-w-full"
                        [title]="customerLabel(line)"
                        (click)="openCustomerDetails(line.customer.id, $event)">
                        {{ customerLabel(line) }}
                      </button>
                    } @else {
                      <span class="text-slate-400">—</span>
                    }
                  </td>
                  <td class="!px-2 max-w-[10rem]">
                    <div class="flex flex-col gap-0.5 min-w-0">
                      <span class="break-all">{{ line.reference || '—' }}</span>
                      <span class="text-xs text-slate-500 whitespace-nowrap">
                        {{ line.cardBrand || '—' }}
                        {{ line.cardNumberMasked || '—' }}
                      </span>
                    </div>
                  </td>
                  <td class="!px-2 whitespace-nowrap text-xs">{{ transactionDateOnly(line.transactionAt) }}</td>
                  <td class="!px-2 text-right whitespace-nowrap">{{ line.amount != null ? (line.amount | number : '1.2-2') : '—' }}</td>
                  <td class="!px-2 text-right whitespace-nowrap">{{ line.totalCommission != null ? (line.totalCommission | number : '1.2-2') : '—' }}</td>
                  <td class="!px-2 text-right font-medium whitespace-nowrap">{{ line.lineTotal != null ? (line.lineTotal | number : '1.2-2') : '—' }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr class="!bg-slate-100 font-semibold border-t-2 border-slate-300">
                  <td colspan="4" class="!px-2 !py-2.5 text-right text-slate-800">Totales</td>
                  <td class="!px-2 !py-2.5 text-right whitespace-nowrap">{{ totals.amount | number : '1.2-2' }}</td>
                  <td class="!px-2 !py-2.5 text-right whitespace-nowrap">{{ totals.totalCommission | number : '1.2-2' }}</td>
                  <td class="!px-2 !py-2.5 text-right whitespace-nowrap text-slate-900">{{ totals.lineTotal | number : '1.2-2' }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7" class="!text-center !text-slate-500">Sin movimientos</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        } @else {
          <p class="text-sm text-slate-500">No hay líneas de movimiento para esta liquidación.</p>
        }

        @if (d.id) {
          <p-button label="Ver página de detalle" icon="pi pi-arrow-right" styleClass="w-full" (onClick)="goToDetail(d.id!)" />
        }
      </div>
    }
  </p-drawer>

  <app-charge-read
    [charge]="selectedCharge()"
    [visible]="isChargeDetailsOpen()"
    (visibleChange)="onChargeDrawerVisibleChange($event)" />

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale()?.id; as saleId) {
          @if (!saleDetailsLoading()) {
            <a
              [routerLink]="['/sales', saleId]"
              class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0">
              <i class="pi pi-external-link text-sm"></i>
              Ver venta
            </a>
          }
        }
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer()?.id; as customerId) {
          @if (!customerDetailsLoading()) {
            <a
              [routerLink]="['/customers', customerId]"
              class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0">
              <i class="pi pi-external-link text-sm"></i>
              Ver cliente
            </a>
          }
        }
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>
</div>
